export default theme => ({
    timelineInner: {
        position: 'relative',
        paddingLeft: 25,
        padding: '50px 0 40px',
        maxWidth: 980,
        margin: '0 auto',
        [theme.breakpoints.up('md')]: {
            paddingLeft: 0,
        },
        '& .line': {
            width: 5,
            position: 'absolute',
            top: 0,
            left: 0,
            bottom: 0,
            backgroundColor: theme.palette.primary.main,
            zIndex: 2,
            [theme.breakpoints.up('md')]: {
                left: 'calc(50% - 2.5px)',
            }
        },
        '& .bg-image': {
            position: 'absolute',
            top: 75,
            left: '50%',
            bottom: 130,
            zIndex: 1,
            width: '100vw',
            transform: 'translateX(-50vw)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            [theme.breakpoints.up('md')]: {
                top: 15,
                bottom: 15,
            },
            '&::before': {
                position: 'absolute',
                content: '""',
                top: 0,
                left: 0,
                right: 0,
                height: 50,
                background: 'linear-gradient(to bottom, ' + theme.palette.secondary.main + ' 5%,rgba(0,0,0,0) 100%)',
                [theme.breakpoints.up('md')]: {
                    height: 150
                },
            },
            '&::after': {
                position: 'absolute',
                content: '""',
                bottom: 0,
                left: 0,
                right: 0,
                height: 50,
                background: 'linear-gradient(to top, ' + theme.palette.secondary.main + ' 5%,rgba(0,0,0,0) 100%)',
                [theme.breakpoints.up('md')]: {
                    height: 150
                },
            }
        },
        '& h1, & h2, & h3, & h4, & h5, & h6': {
            color: theme.palette.secondary.contrastText,
            fontSize: 16,
            lineHeight: 1.5,
            letterSpacing: '0.04em',
            fontFamily: theme.headerFont,
            fontWeight: 'bold',
            position: 'relative',
            margin: '0 0 36px',
            zIndex: 3,
            textTransform: 'uppercase',
            padding: '0 8px',
            [theme.breakpoints.up('md')]: {
                padding: '0 20px',
                fontSize: 24,
                lineHeight: 1.25,
                marginTop: 250,
            },
            '&::before': {
                content: '""',
                width: 5,
                height: 40,
                backgroundColor: theme.palette.primary.main,
                display: 'block',
                position: 'absolute',
                top: 0,
                left: -20,
                [theme.breakpoints.up('md')]: {
                    left: 'calc(100% + 5px)',
                },
            }
        },
        '& .year': {
            fontSize: 32,
            letterSpacing: '0.048em',
            lineHeight: 1.25,
            color: theme.palette.secondary.contrastText,
            marginTop: -20,
            fontFamily: theme.headerFont,
            padding: '0 12px',
            [theme.breakpoints.up('md')]: {
                fontSize: 64,
                lineHeight: 1,
                letterSpacing: '0.056em',
                padding: '0 24px',
                marginTop: -40,
            },
            '&::after': {
                width: 22,
                height: 5,
                margin: '16px 0',
                content: '""',
                backgroundColor: theme.palette.primary.main,
                display: 'block',
                [theme.breakpoints.up('md')]: {
                    margin: '32px 0',
                    width: 40,
                },
            }
        },
        '& p, & ul': {
            color: theme.palette.secondary.contrastText,
            padding: '0 12px',
            fontSize: 14,
            letterSpacing: '0.024em',
            lineHeight: 1.75,
            margin: 0,
            zIndex: 3,
            [theme.breakpoints.up('md')]: {
                fontSize: 16,
                lineHeight: 2,
                letterSpacing: '0.032em',
                padding: '0 24px',
            },
            '& li': {
                marginBottom: 12,
            },
            '& a': {
                color: theme.palette.secondary.contrastText,
                transition: 'color .3s ease-in-out',
                '&:hover, &:focus': {
                    color: theme.palette.primary.main,
                }
            }
        }
    },
    timelineInnerTheme: {
        ...theme.timelineInnerTheme,
    }
})